export default __webpack_public_path__ + "static/media/X.9a322b4a.png";